module.exports = __webpack_public_path__ + "img/feature_buy_en.619c3cc0.png";